import { playdataNewsListPageQueryOptions } from "@data/public-page-data-query"
import * as m from "@paraglide/messages"
import PlaydataHome from "@playdata/PlaydataHome"
import type { SupportedLocale } from "@site-types/content"
import { createFileRoute } from "@tanstack/react-router"
import { playdataRouteHead } from "@utils/playdata-route-head"

export const Route = createFileRoute("/$locale/playdata/")({
  /*
   * The home page carries a three-post news strip, same as the live site.
   *
   * A failure here drops the strip rather than the page. Every other section is
   * static copy, and losing the whole marketing home page because a news query
   * could not reach the database is the wrong trade — the news list at
   * /playdata/news still surfaces the error where it is the point of the page.
   */
  loader: async ({ context, params }) => {
    try {
      return await context.queryClient.ensureQueryData(
        playdataNewsListPageQueryOptions(params.locale as SupportedLocale)
      )
    } catch {
      return { news: [] }
    }
  },
  head: ({ params }) => {
    const locale = params.locale as SupportedLocale
    return playdataRouteHead({
      description: m.playdata_home_meta_description({}, { locale }),
      locale,
      path: "/playdata",
      title: m.playdata_home_meta_title({}, { locale }),
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = Route.useParams()
  const data = Route.useLoaderData()
  return (
    <PlaydataHome
      locale={locale as SupportedLocale}
      news={data.news}
    />
  )
}
